// extracted by mini-css-extract-plugin
export default {"wrapper":"PasswordInput_wrapper__jZ5Vs","icon":"PasswordInput_icon__jfGVX"};